import { Component, OnInit, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../core/services/api.service';
import { RentPayment } from '../../core/models/api.models';

@Component({
  selector: 'app-rent-payments',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './rent-payments.component.html',
  styleUrl: './rent-payments.component.scss',
})
export class RentPaymentsComponent implements OnInit {
  private readonly api = inject(ApiService);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly rows = signal<RentPayment[]>([]);
  readonly page = signal(1);
  readonly limit = signal(20);
  readonly total = signal(0);

  ngOnInit(): void {
    this.load();
  }

  load(page = this.page()): void {
    this.loading.set(true);
    this.error.set(null);
    this.api.getRentPayments(page, this.limit()).subscribe({
      next: (data) => {
        this.rows.set(data.rows || []);
        this.page.set(data.page);
        this.limit.set(data.limit);
        this.total.set(data.total);
        this.loading.set(false);
      },
      error: (err: { message?: string }) => {
        this.error.set(err?.message || 'Failed to load rent payments');
        this.loading.set(false);
      },
    });
  }

  userLabel(row: RentPayment): string {
    const u = row.user;
    if (!u) return String(row.user_id ?? '—');
    const name = `${u.first_name || ''} ${u.last_name || ''}`.trim();
    return name || u.email || String(row.user_id ?? '—');
  }

  totalPages(): number {
    return Math.max(1, Math.ceil(this.total() / this.limit()));
  }

  prev(): void {
    if (this.page() > 1) this.load(this.page() - 1);
  }

  next(): void {
    if (this.page() < this.totalPages()) this.load(this.page() + 1);
  }
}
